<template>
<div class="chapter">
<div class="inner_page">
<p class="blockquote1"><a id="ch00_fm07_pre2"></a><a id="page_xiii"></a><em>But I dwell now well in the making of the future. Little by little, time is kneading me into shape. A child is not frightened at the thought of being patiently turned into an old man. I too play my games. I count the dials, the levers, the buttons, the knobs of my kingdom.</em></p>
<p class="attribution"><span class="small">ANTOINE DE SAINT-EXUPÉRY</span>, <em>Flight to Arras</em><a id="page_xiv"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm07_pre2.vue?1728c8e4